import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name:       'formatIban',
  standalone: true
})
export class FormatIbanPipe implements PipeTransform {
  transform(value: any): any {
    if (!value) {
      return value;
    }
    return value
      .split(' ')
      .join('')
      .replace(/(.{4})/g, '$1 ')
      .trim()
      .toUpperCase();
  }
}
